import {
    ActivityLevelBadge,
    materialLevelsColors,
    materialLevelsIcons,
} from "@common/chapters/ActivityLevelBadge"
import FilledButtonM from "@common/components/button/FilledButtonM"
import IconButtonM from "@common/components/button/IconButtonM"
import TextInputM from "@common/components/input/TextInputM"
import MediaPickerButton from "@common/components/media/MediaPickerButton"
import TextM from "@common/components/text/TextM"
import { PaginatedFlatList } from "@common/screens/PaginatedFlatList"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { formIds } from "@data/constants/formConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { activitiesService } from "@data/services/activitiesService"
import { hasRole } from "@data/utility/ability"
import { addMediaToField } from "@data/utility/Utils"
import React, { useContext, useEffect, useRef, useState } from "react"
import { useController } from "react-hook-form"
import { Dimensions, Keyboard, ScrollView, View } from "react-native"
import { ActivityIndicator, SegmentedButtons } from "react-native-paper"
import { connect } from "react-redux"
import ServerSearch from "../../common/components/input/ServerSearch"
import {
    activitySlugsMaterialTitleExample,
    materialPlaceholder,
    undefinedMaterialSlug,
} from "../activity/todo/ActivityPicker"
import MaterialItemComponent from "./MaterialItemComponent"

const MaterialPicker = (props) => {
    const {
        control,
        goToNextStep,
        register,
        errors,
        formValues,
        setFormValues,
        field,
        trigger,
        manageTodo = false,
    } = props

    const chapterId = control._formValues?.chapter?.id

    const [images, setImages] = useState(
        control._formValues?.material_attachments ?? []
    )

    const activityTemplate = props.activityTemplates?.find(
        (activityTemplate) =>
            activityTemplate?.id === formValues?.activity_template_id
    )

    const [urlParams, setUrlParams] = useState({
        chapter_id: chapterId,
        activity_type: activityTemplate?.type,
    })

    const [pdf, setPdf] = useState(null)
    const uMaterialSlug = undefinedMaterialSlug(activityTemplate?.slug)

    const [materialAction, setMaterialAction] = useState(
        hasRole(props.user, "student") ? "create" : "search"
    )

    const [isMaterialOpen, setMaterialOpen] = useState(false)

    const handleShowMaterialModal = () => setMaterialOpen(!isMaterialOpen)

    const materialTextRef = useRef()
    const materialChapterRef = useRef()
    const flatListRef = useRef()

    const { field: materialUrlField } = useController({
        control,
        name: "material_url",
    })
    const { field: materialAttachmentsField } = useController({
        control,
        name: "material_attachments",
    })
    const { field: materialTitleField } = useController({
        control,
        name: "material_title",
    })
    const { field: materialLevelField } = useController({
        control,
        name: "material_level",
    })
    const dimensions = useContext(DimensionsContext)

    const levelButtonsDisabled =
        hasRole(props.user, "student") ||
        (activityTemplate?.slug !== "go_exo" &&
            activityTemplate?.slug !== "go_homework_oral")

    const levelButtonsStyle = {
        fontSize: dimensions.width < 800 ? 9 : 10,
    }

    useEffect(() => {
        if (
            activityTemplate?.slug !== "go_exo" &&
            activityTemplate?.slug !== "go_homework_oral"
        ) {
            materialLevelField.onChange(1)
            setFormValues({
                ...control._formValues,
                material_level: 1,
            })
        }
    }, [])

    useEffect(() => {
        addMediaToField(materialAttachmentsField, images)
        setFormValues({
            ...control._formValues,
            [materialAttachmentsField?.name]: images?.map((file) => {
                return {
                    type: "image/png",
                    height: file?.height,
                    width: file?.width,
                    uri: file?.uri,
                }
            }),
        })
    }, [images])

    useEffect(() => {
        if (materialAction === "create") {
            field.onChange(null)
        }
    }, [materialAction])

    // Sync PDF with form field
    useEffect(() => {
        if (pdf) {
            const pdfFile = {
                uri: pdf,
                type: "application/pdf",
                name: `document-${Date.now()}.pdf`,
                size: 0,
            }

            addMediaToField(materialAttachmentsField, [pdfFile])
            setFormValues({
                ...control._formValues,
                [materialAttachmentsField?.name]: pdfFile,
            })
        }
    }, [pdf])

    const renderNewMaterial = () => {
        return (
            <>
                <ScrollView
                    contentContainerStyle={{
                        paddingBottom: 280,
                    }}
                >
                    {chapterId && !hasRole(props.user, "student") && (
                        <IconButtonM
                            size={30}
                            icon={"search"}
                            iconColor={theme.colors.primary}
                            onPress={() => {
                                setMaterialAction("search")
                            }}
                            style={{
                                alignSelf: "flex-end",
                            }}
                        />
                    )}
                    {}
                    {}
                    <MediaPickerButton
                        images={images}
                        setImages={setImages}
                        pdf={pdf}
                        setPdf={setPdf}
                        url={materialUrlField?.value || ""}
                        setUrl={(newUrl) => {
                            materialUrlField.onChange(newUrl)
                            setFormValues({
                                ...control._formValues,
                                material_url: newUrl,
                            })
                            trigger("material_url")
                        }}
                        buttonLabel={`Ajouter ${uMaterialSlug}`}
                        formId={formIds.NEW_MATERIAL}
                        videoCourseMode={
                            activityTemplate?.slug === "video_course"
                        }
                        onShowMaterialModal={handleShowMaterialModal}
                        onUrlTitleChange={(title) => {
                            materialTitleField.onChange(title)
                            setFormValues({
                                ...control._formValues,
                                material_title: title,
                            })
                        }}
                        attachments={materialAttachmentsField?.value}
                    />
                    {activityTemplate?.slug !== "video_course" && (
                        <TextInputM
                            {...register("material_title")}
                            ref={materialChapterRef}
                            label={"Titre de l'activité"}
                            placeholder={
                                activitySlugsMaterialTitleExample[
                                    activityTemplate?.slug
                                ]
                            }
                            onChangeAdditional={(value) => {
                                setFormValues({
                                    ...control._formValues,
                                    material_chapter: value,
                                })
                            }}
                            onSubmitEditing={() => {
                                Keyboard.dismiss()
                            }}
                            returnKeyType={"done"}
                            contentContainerStyle={{
                                width:
                                    IS_WEB || dimensions?.width > 800
                                        ? (dimensions?.width * 3) / 5
                                        : "100%",
                                marginBottom: 10,
                            }}
                            control={control}
                            errors={errors}
                        />
                    )}
                    {}
                    {!hasRole(props.user, "student") && (
                        <TextInputM
                            {...register("material_text")}
                            label={"Indications"}
                            ref={materialTextRef}
                            placeholder={materialPlaceholder(
                                activityTemplate?.slug
                            )}
                            onSubmitEditing={() => {
                                materialChapterRef.current?.focus()
                            }}
                            onChangeAdditional={(value) => {
                                setFormValues({
                                    ...control._formValues,
                                    material_text: value,
                                })
                            }}
                            returnKeyType={"next"}
                            contentContainerStyle={{
                                width:
                                    IS_WEB || dimensions?.width > 800
                                        ? (dimensions?.width * 3) / 5
                                        : "100%",
                            }}
                            multiline={true}
                            style={{
                                height: 120,
                                marginBottom: 6,
                            }}
                            control={control}
                            errors={errors}
                        />
                    )}

                    {!!control._formValues?.estimated_duration && (
                        <>
                            {levelButtonsDisabled ? (
                                <View
                                    style={{
                                        marginTop: 10,
                                        flexDirection: "row",
                                        alignItems: "center",
                                        alignSelf: "center",
                                        width:
                                            IS_WEB || dimensions?.width > 800
                                                ? (dimensions?.width * 3) / 5
                                                : "100%",
                                    }}
                                >
                                    <TextM
                                        style={{
                                            alignSelf: "flex-start",
                                            marginRight: 3,
                                        }}
                                        fontSize={12}
                                    >
                                        Niveau de difficulté par défaut :{" "}
                                    </TextM>
                                    <ActivityLevelBadge
                                        level={1}
                                        style={{ marginTop: 0 }}
                                    />
                                </View>
                            ) : (
                                <View
                                    style={{
                                        marginTop: 10,
                                        alignSelf: "center",
                                        width:
                                            IS_WEB || dimensions?.width > 800
                                                ? (dimensions?.width * 3) / 5
                                                : "100%",
                                    }}
                                >
                                    <TextM
                                        style={{
                                            alignSelf: "flex-start",
                                            marginBottom: 5,
                                        }}
                                    >
                                        Estime le niveau de difficulté
                                    </TextM>
                                    <SegmentedButtons
                                        {...register("material_level")}
                                        value={materialLevelField?.value}
                                        onValueChange={(value) => {
                                            materialLevelField.onChange(value)
                                            setFormValues({
                                                ...control._formValues,
                                                material_level: value,
                                            })
                                        }}
                                        buttons={[
                                            {
                                                value: 1,
                                                label: props
                                                    .materialLevels?.[1],
                                                labelStyle: levelButtonsStyle,
                                                checkedColor:
                                                    materialLevelsColors?.[1],
                                                disabled: false,
                                                icon: materialLevelsIcons?.[1],
                                            },
                                            {
                                                value: 2,
                                                label: props
                                                    .materialLevels?.[2],
                                                labelStyle: levelButtonsStyle,
                                                checkedColor:
                                                    materialLevelsColors?.[2],
                                                disabled: levelButtonsDisabled,
                                                icon: materialLevelsIcons?.[2],
                                            },
                                            {
                                                value: 3,
                                                label: props
                                                    .materialLevels?.[3],
                                                labelStyle: levelButtonsStyle,
                                                checkedColor:
                                                    materialLevelsColors?.[3],
                                                style: {},
                                                disabled: levelButtonsDisabled,
                                                icon: materialLevelsIcons?.[3],
                                            },
                                        ]}
                                    />
                                </View>
                            )}
                        </>
                    )}
                    <FilledButtonM
                        onPress={() => {
                            goToNextStep()
                        }}
                        label={"Continuer"}
                        color={theme.colors.primary}
                        style={{
                            width: "100%",
                            alignSelf: "center",
                            marginTop: 30,
                        }}
                    />
                </ScrollView>
            </>
        )
    }

    const renderMaterialsList = () => {
        return (
            <View
                style={{
                    width: Dimensions.get("window").width,
                    alignItems: "center",
                    flex: 1,
                    alignSelf: "center",
                }}
            >
                <PaginatedFlatList
                    ref={flatListRef}
                    data={props.materials}
                    noRefreshWhenNoResults={true}
                    contentContainerStyle={{
                        paddingBottom: 100,
                    }}
                    noActivityIndicator
                    additionalOnRefresh={() => {}}
                    additionalRefreshing={false}
                    requestApiService={activitiesService.materialsSearch}
                    requestRouteParams={null}
                    requestUrlParams={urlParams}
                    requestData={null}
                    style={{
                        width: Dimensions.get("window").width,
                        flex: 1,
                    }}
                    ListEmptyComponent={
                        props.materials?.length === 0 && (
                            <>
                                <TextM
                                    style={{
                                        textAlign: "center",
                                        marginTop: 20,
                                    }}
                                >
                                    Aucun enoncé trouvé
                                </TextM>
                            </>
                        )
                    }
                    ListHeaderComponent={
                        <View style={{ width: dimensions.width - 40 }}>
                            <View
                                style={{
                                    flexDirection: "row",
                                }}
                            >
                                <ServerSearch
                                    style={{
                                        width: dimensions.width - 100,
                                        boxShadow: "none",
                                        borderWidth: 1,
                                        borderColor: theme.colors.lightMore,
                                        marginRight: 10,
                                        marginTop: 4,
                                    }}
                                    request={props.materialsSearchRequest}
                                    urlParams={urlParams}
                                    setUrlParams={setUrlParams}
                                />
                                <IconButtonM
                                    size={30}
                                    icon={"plus"}
                                    iconColor={theme.colors.primary}
                                    onPress={() => {
                                        setMaterialAction("create")
                                    }}
                                    style={{
                                        alignSelf: "flex-end",
                                    }}
                                />
                            </View>

                            {IS_WEB && props.materialsSearchRequest && (
                                <ActivityIndicator
                                    color={theme.colors.primary}
                                    style={{ marginVertical: 20 }}
                                />
                            )}

                            {props.materials?.length > 0 && (
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        marginTop: 30,
                                    }}
                                >
                                    <TextM fontWeight={"Bold"} fontSize={18}>
                                        {"Enoncés".toUpperCase()}
                                    </TextM>
                                    <View
                                        style={{
                                            padding: 3,
                                            borderRadius: 50,
                                            backgroundColor:
                                                theme.colors.greyAlt,
                                            width: 24,
                                            height: 24,
                                            marginLeft: 10,
                                            alignItems: "center",
                                        }}
                                    >
                                        <TextM
                                            color={theme.colors.white}
                                            fontSize={14}
                                            fontWeight={"Bold"}
                                        >
                                            {props.materials?.length}
                                        </TextM>
                                    </View>
                                </View>
                            )}
                        </View>
                    }
                    renderItem={(item) => {
                        return (
                            <MaterialItemComponent
                                material={item.item}
                                key={item.index}
                                manageTodo={manageTodo}
                                field={field}
                                goToNextStep={goToNextStep}
                                register={register}
                                materialUrlField={materialUrlField}
                                materialAttachmentsField={
                                    materialAttachmentsField
                                }
                                materialTitleField={materialTitleField}
                            />
                        )
                    }}
                />
                <FilledButtonM
                    onPress={() => {
                        goToNextStep()
                    }}
                    label={"Continuer"}
                    color={theme.colors.primary}
                    style={{
                        width: dimensions.width / 2,
                        alignSelf: "center",
                        marginTop: 30,
                    }}
                />
            </View>
        )
    }

    return (
        <>
            {materialAction === "create" || !chapterId
                ? renderNewMaterial()
                : renderMaterialsList()}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        activityTemplates: state.data.staticData?.activity_templates,
        materialLevels: state.data?.staticData?.material_levels,
        materials: state.data.materials?.materialsList,
        materialsSearchRequest: state.api.materialsSearch?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(MaterialPicker)
